import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { ConfigTestCompleteComponent } from './pages/config-test/config-test-complete.component';
import { MultilanguageTestCompleteComponent } from './pages/multilanguage-test/multilanguage-test-complete-redesigned.component';
import { AuthTestCompleteComponent } from './pages/auth-test/auth-test.component';
import { NavigationTestCompleteComponent } from './pages/navigation/navigation-test-complete-redesigned.component';
import { TracesTestCompleteComponent } from './pages/traces/traces-test-complete-redesigned.component';
import { SecurityTestCompleteComponent } from './pages/security-test/security-test-complete-redesigned.component';
import { TestWebcomponentComponent } from './pages/test-webcomponent/test-webcomponent.component';
import { WebsocketTesterComponent } from './pages/websocket/websocket.component';
import { CommonTestComponent } from './pages/common-test/common-test.component';
import { DevLogsTestComponent } from './pages/devlogs-test/devlogs-simple.component';
import { SeoTestComponent } from './pages/seo-test/seo-simple.component';
import { SessionTestComponent } from './pages/session-test/session-simple.component';
import { HttpInterceptorsTestComponent } from './pages/http-interceptors-test/http-interceptors-test.component';
import { ProtectedRouteComponent } from './pages/protected-route/protected-route.component';
import { ProtectedWithRolesComponent } from './pages/protected-with-roles/protected-with-roles.component';
import { AccessDeniedComponent } from './pages/access-denied/access-denied.component';
import { authGuardCanActivate, authGuardCanMatchFn, oauthCallbackGuard } from '@argo/authentication';

import { ValidFormsTestComponent } from './pages/valid-forms-test/valid-forms-test.component';

export const routes: Routes = [
  { path: '', component: HomeComponent},
  
  // HOME - Página de bienvenida
  { path: 'home', component: HomeComponent },
  
  // ACCESS DENIED - Página de acceso denegado
  { path: 'access-denied', component: AccessDeniedComponent },
  
  // TEST PLAYGROUNDS
  {
    path: 'test',
    children: [
      { path: '', redirectTo: 'auth', pathMatch: 'full' },
      { path: 'auth', component: AuthTestCompleteComponent },
      { path: 'common', component: CommonTestComponent },
      { path: 'config', component: ConfigTestCompleteComponent },
      { path: 'http-interceptors', component: HttpInterceptorsTestComponent },
      { path: 'devlogs', component: DevLogsTestComponent },
      { path: 'multilanguage', component: MultilanguageTestCompleteComponent },
      { path: 'navigation', component: NavigationTestCompleteComponent },
      { path: 'seo', component: SeoTestComponent },
      { path: 'session', component: SessionTestComponent },
      { path: 'traces', component: TracesTestCompleteComponent },
      { path: 'security', component: SecurityTestCompleteComponent },
      { path: 'websocket', component: WebsocketTesterComponent },
      { path: 'valid-forms', component: ValidFormsTestComponent },
    ]
  },
  
  // MODULE FEDERATION
  {
    path: 'module-federation',
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      // TODO: Add module federation routes
      { path: 'home', component: TestWebcomponentComponent }, // Placeholder
    ]
  },
  
  // WEBCOMPONENT
  {
    path: 'webcomponent',
    children: [
      { path: '', component: TestWebcomponentComponent },
    ]
  },

  // PROTECTED ROUTES (Guards Test)
  {
    path: 'protected',
    canActivate: [authGuardCanActivate],
    component: ProtectedRouteComponent,
    data: {
      authGuard: {
        requireAuthentication: true
      }
    }
  },
  {
    path: 'protected-roles',
    component: ProtectedWithRolesComponent,
    canMatch: [authGuardCanMatchFn],
    data: {
      authGuard: {
        requireAuthentication: true,
        requiredRoles: ['ADMIN', 'USER']
      }
    }
  },
  
  { path: '**', redirectTo: 'test/auth' }
];

